import {
  incompletePublicEmailVerification,
  pendingInfo,
  pendingPublicNoBrandVerified,
  pendingPublicNoEmailVerified,
  pendingSPInfo,
} from 'containers/pages/Messaging/CampaignDialog/constants';

export const getTextRegistrationStatus = (
  isVersion2: boolean,
  isPublic: boolean,
  isSoleProprietor: boolean,
  isBrandVerified: boolean,
) => {
  if (isPublic) {
    if (!isVersion2) {
      return pendingInfo;
    }
    if (!isBrandVerified) {
      return pendingPublicNoBrandVerified;
    }
    return pendingPublicNoEmailVerified;
  }
  if (isSoleProprietor && !isBrandVerified) {
    return pendingSPInfo;
  }
  return pendingInfo;
};

export const getTextRegistration = (
  isPublic: boolean,
  authVettingStatus: null | string,
) => {
  if (isPublic) {
    if (authVettingStatus === null) {
      return pendingPublicNoBrandVerified;
    }
    if (authVettingStatus === 'PENDING') {
      return pendingPublicNoEmailVerified;
    }
    if (authVettingStatus === 'EXPIRED') {
      return incompletePublicEmailVerification;
    }
  }
  return pendingInfo;
};

export const getTextRegistrationSoleProp = (
  isSoleProprietor: boolean,
  isBrandVerified: boolean,
) => {
  if (isSoleProprietor && !isBrandVerified) {
    return pendingSPInfo;
  }
  return pendingInfo;
};
